import React from 'react'
import { LinkContainer } from 'react-router-bootstrap'
import { Row, Col, Card } from 'react-bootstrap'

const sections = [
  { title: 'Tournaments', icon: 'fa-trophy', links: [{ label: 'View All', to: '/admin/tournaments' }, { label: 'Create New', to: '/admin/tournaments/create' }] },
  { title: 'Courses', icon: 'fa-golf-ball-tee', links: [{ label: 'View All', to: '/admin/courses' }, { label: 'Create New', to: '/admin/courses/create' }] },
  { title: 'Contests', icon: 'fa-flag', links: [{ label: 'View All', to: '/admin/contests' }, { label: 'Create New', to: '/admin/contests/create' }] },
  { title: 'Awards', icon: 'fa-medal', links: [{ label: 'View All', to: '/admin/awards' }, { label: 'Create New', to: '/admin/awards/create' }] },
  { title: 'Payment Types', icon: 'fa-credit-card', links: [{ label: 'View All', to: '/admin/payment-types' }, { label: 'Create New', to: '/admin/payment-types/create' }] },
  { title: 'Users', icon: 'fa-users', links: [{ label: 'View All', to: '/admin/userList' }] },
]

function AdminDashboardScreen() {
  return (
    <div>
      <h2 className="mb-4">Admin Dashboard</h2>
      <Row>
        {sections.map((section) => (
          <Col key={section.title} sm={12} md={6} lg={4} className="mb-4">
            <Card className="h-100 shadow-sm">
              <Card.Body>
                <Card.Title>
                  <i className={`fa-solid ${section.icon} me-2`}></i>
                  {section.title}
                </Card.Title>
                <div className="d-flex flex-column gap-2 mt-3">
                  {section.links.map((link) => (
                    <LinkContainer key={link.label} to={link.to}>
                      <a className="btn btn-outline-secondary btn-sm">{link.label}</a>
                    </LinkContainer>
                  ))}
                </div>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  )
}

export default AdminDashboardScreen
